import { countries } from "@redotech/locale/countries";
import { defineSchema, SchemaInstance } from "../../type-system/schema";

export const trackingPageFlowSchema = defineSchema({
  fields: {
    orderId: {
      dataType: "Text",
      documentation: "The order ID for the tracking page view",
    },
    redoOrderId: {
      dataType: "Text",
      documentation: "The Redo order ID for accessing order data",
    },
    redoCustomerId: {
      dataType: "Text",
      documentation: "The Redo customer ID for accessing customer data",
    },
    destinationCountry: {
      dataType: "Enum",
      values: countries.map((country) => country.code),
      documentation: "The tracking page ID for accessing tracking page data",
    },
  },
});

export const exampleTrackingPageFlowSchemaInstance: SchemaInstance<
  typeof trackingPageFlowSchema
> = {
  orderId: "order-123",
  redoOrderId: "redo-order-123",
  redoCustomerId: "redo-customer-123",
  destinationCountry: "US",
};

export function createTrackingPageFlowSchemaInstance(
  orderId: string,
  redoOrderId: string,
  redoCustomerId: string,
  destinationCountry: string,
): SchemaInstance<typeof trackingPageFlowSchema> {
  return { orderId, redoOrderId, redoCustomerId, destinationCountry };
}
